module.exports = __webpack_public_path__ + "img/onboarding-page-light.8a7d2bf6.svg";